export default __webpack_public_path__ + "static/media/contactgif.55b4d157.gif";